<template>
  <CardInside
    :no-padding="!loading"
    data-id="dashboard-imap-smtp"
    :data-imap-smtp-inbox-id="inboxId"
    :data-loading="loading ? '1' : '0'"
  >
    <template #body>
      <SMTPIMAPAccess :inbox-id="inboxId" />
    </template>
    <template #help>
      <p>Connect to your inboxes using mail apps or IMAP/SMTP libraries.</p>
      <p>
        <a
          class="text-link"
          href="https://docs.mailslurp.com/imap-smtp/"
          target="_blank"
          >See configuration guide</a
        >. To generate a PLAIN AUTH token use the
        <a
          class="text-link"
          target="_blank"
          href="https://www.mailslurp.com/tools/plain-authentication-encoder/"
          >base64 encoding tool</a
        >.
      </p>
      <p>
        To connect external inboxes via IMAP and SMTP use
        <NuxtLink class="text-link" to="/connectors/">inbox connectors</NuxtLink
        >.
      </p>
    </template>
  </CardInside>
</template>
<script lang="ts" setup>
import { ref } from 'vue';
import SMTPIMAPAccess from '../../components/dashboard/SMTPIMAPAccess.vue';
import CardInside from '../../components/form/CardInside.vue';
withDefaults(
  defineProps<{
    inboxId?: string | undefined;
  }>(),
  { inboxId: undefined },
);
const loading = ref(false);
</script>
